/* tempexp_18086-start */

import type { Space } from '@mail/cross-sizes-utils';
import { Spacing, Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { useReferralLink } from 'reactApp/ui/ReferralProgram/ReferralModal/hooks/useReferralLink';
import { ReferralInfo } from 'reactApp/ui/ReferralProgram/ReferralModal/Info/ReferralInfo';

import styles from './ReferralLinkBlock.css';

interface ReferralLinkBlockProps {
    quota: Space;
    isMaxQuota: boolean;
    isMobile?: boolean;
}

export function ReferralLinkBlock({ quota, isMaxQuota, isMobile = false }: ReferralLinkBlockProps) {
    const { copyOrShare, buttonText, disabled } = useReferralLink();
    const title = quota.original ? `У вас ${quota.value}` : 'Это ваша реферальная ссылка';
    const noBonusDescription = isMobile ? 'Поделитесь ссылкой и пригласите ещё друга' : 'Скопируйте её и отправьте друзьям';
    const bonusDescription = isMaxQuota
        ? 'Это максимальное количество бонусов'
        : ` ${isMobile ? 'Поделитесь ссылкой' : 'Скопируйте ссылку'} и пригласите ещё ${isMobile ? 'друга' : 'друзей'}`;
    const description = quota.original ? bonusDescription : noBonusDescription;

    return (
        <>
            <div className={classNames(styles.root, { [styles.rootMobile]: isMobile })}>
                <div className={styles.textContainer}>
                    <Text className={styles.title}>{title}</Text>
                    <Text className={styles.description}>{description}</Text>
                </div>
                <Button
                    disabled={disabled}
                    className={styles.button}
                    theme="vk"
                    primary
                    sizeMode={ButtonSizeMode.small}
                    onClick={copyOrShare}
                >
                    {buttonText}
                </Button>
            </div>
            {quota.original ? null : (
                <>
                    <Spacing size={isMobile ? 8 : 12} />
                    <ReferralInfo isMobile={isMobile} />
                </>
            )}
        </>
    );
}

/* tempexp_18086-end */
